/* 
 * @description: 当前用户token管理类
 * @author: Jason Wong 
 * @since: 2019-12-18 18:33:58 
 */

const TOKEN_PREFIX = "Z2FR17J4I9_";
const AUTORITY_TOKEN_NAME = TOKEN_PREFIX + "D_T";
const REFRESH_TOKEN_NAME = TOKEN_PREFIX + "R_T";
const ACCESS_TOKEN_NAME = TOKEN_PREFIX + "A_T";

export default {
    getRefreshToken(){
        return window.localStorage.getItem(REFRESH_TOKEN_NAME);
    },
    setRefreshToken(value){
        window.localStorage.setItem(REFRESH_TOKEN_NAME,value);
    },

    getAccessToken(){
        return window.localStorage.getItem(ACCESS_TOKEN_NAME);
    },
    setAccessToken(value){
        return window.localStorage.setItem(ACCESS_TOKEN_NAME,value);
    },

    clearToken(){
        window.localStorage.removeItem(AUTORITY_TOKEN_NAME);
        window.localStorage.removeItem(ACCESS_TOKEN_NAME);
        window.localStorage.removeItem(REFRESH_TOKEN_NAME);
    }
}